import { BaSeTheme } from '../../theme';
import { Color } from '../../utils/color-transformation/color';
import { ColorMapper } from '../../utils/color-transformation/color-mapper';

export const mapSizeCheckbox = {
  small: 13,
  medium: 16,
};

interface MapBadgeValue {
  color: string;
  style: { bgC: string; border: string };
}
interface MapBadgeValues {
  primary: MapBadgeValue;
  secondary: MapBadgeValue;
  tertiary: MapBadgeValue;
}

type KeyColorMapper = keyof typeof ColorMapper;
type ColorMapperWithForeground = { foreground: string };
type ColorMapperWithHoverWithDefaultLight = {
  hover: { defaultLight: string };
};
type ColorMapperWithHoverWithDefaultDark = {
  hover: { defaultDark: string };
};

export const mapBadgeValues = (color = 'default'): MapBadgeValues => {
  const colorIsMapped =
    color === BaSeTheme.components.button.colors.default ||
    color === BaSeTheme.components.button.colors.destructive ||
    color === BaSeTheme.components.button.colors.attention ||
    color === BaSeTheme.components.button.colors.confirmation;
  // color === BaSeTheme.components.button.colors.negative;

  if (colorIsMapped) {
    return {
      primary: {
        color: BaSeTheme.colors.defaultColors.white,
        style: {
          bgC: (
            ColorMapper[color as KeyColorMapper] as ColorMapperWithForeground
          ).foreground,
          border: BaSeTheme.colors.defaultColors.white,
        },
      },
      secondary: {
        color: (
          ColorMapper[
            color as KeyColorMapper
          ] as ColorMapperWithHoverWithDefaultDark
        ).hover.defaultDark,
        style: {
          bgC: (
            ColorMapper[
              color as KeyColorMapper
            ] as ColorMapperWithHoverWithDefaultLight
          ).hover.defaultLight,
          border: (
            ColorMapper[color as KeyColorMapper] as ColorMapperWithForeground
          ).foreground,
        },
      },
      tertiary: {
        color: (
          ColorMapper[
            color as KeyColorMapper
          ] as ColorMapperWithHoverWithDefaultDark
        ).hover.defaultDark,
        style: {
          bgC: (
            ColorMapper[
              color as KeyColorMapper
            ] as ColorMapperWithHoverWithDefaultLight
          ).hover.defaultLight,
          border: 'none',
        },
      },
    };
  }
  const customColorHsv = Color.generateFromHex(color);
  return {
    primary: {
      color: BaSeTheme.colors.defaultColors.white,
      style: {
        bgC:
          color && customColorHsv
            ? customColorHsv.toString()
            : BaSeTheme.colors.institucionais.azulSebrae36,
        border: BaSeTheme.colors.defaultColors.white,
      },
    },
    secondary: {
      color: ColorMapper.dark.hover.create(
        color ? color : BaSeTheme.colors.institucionais.azulSebrae36,
      ),
      style: {
        bgC: ColorMapper.light.hover.create(
          color ? color : BaSeTheme.colors.institucionais.azulSebrae36,
        ),
        border:
          color && customColorHsv
            ? customColorHsv.toString()
            : BaSeTheme.colors.institucionais.azulSebrae36,
      },
    },
    tertiary: {
      color: ColorMapper.dark.hover.create(
        color ? color : BaSeTheme.colors.institucionais.azulSebrae36,
      ),
      style: {
        bgC: ColorMapper.light.hover.create(
          color ? color : BaSeTheme.colors.institucionais.azulSebrae36,
        ),
        border: 'none',
      },
    },
  };
};
